type LayoutProps = {
  children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return <div className="flex md:mt-0 bg-gray-200 min-h-screen text-primary">{children}</div>;
};

export default Layout;
